
export default {
  lawyerManagerApi: {
    lawFirmManager: {
      getList: 'api/lawFirmManager/getList',
      add: 'api/lawFirmManager/add',
      reportFirm: 'api/lawFirmManager/reportFirm',
      update: 'api/lawFirmManager/update',
      del: 'api/lawFirmManager/del',
      getOptions: 'api/lawFirmManager/getOptions',
    },
    lawyerManager: {
      getList: '/api/lawyerManager/getList',
      getDetail: '/api/lawyerManager/getDetail',
      save: '/api/lawyerManager/save',
      update: '/api/lawyerManager/update',
      del: '/api/lawyerManager/del',
      getLawyerRoles: '/api/lawyerManager/getLawyerRoles',
      changeAccountStatus: '/api/lawyerManager/changeAccountStatus',
      importData: '/api/lawyerManager/importData',
      downloadTemplate: '/api/lawyerManager/download/template',
      export: '/api/lawyerManager/export',
      resetLawyerPd: '/api/lawyerManager/resetLawyerPd',
      getLawyerInfo: '/api/lawyerManager/getLawyerInfo',
      uploadLawyerInfo: '/api/lawyerManager/uploadLawyerInfo',
      getLawyerOptions: '/api/lawyerManager/getLawyerOptions',
    },
    lawyerTag: {
      tagOptions: '/api/lawyerTag/tagOptions',
      pageList: '/api/lawyerTag/pageList',
      saveOrUpdate: '/api/lawyerTag/saveOrUpdate',
      delTag: '/api/lawyerTag/delTag',
    },
    lawyerRegister: {
      getList: '/api/lawyerRegister/getList',
      getDetail: '/api/lawyerRegister/getDetail',
      submit: '/api/lawyerRegister/submit',
      audit: '/api/lawyerRegister/audit',
    },
    lawyerDSApi: {
      getLawyerList: 'api/lawyerDataSourceApi/getLawyerList',
      getLawyerInfo: 'api/lawyerDataSourceApi/getLawyerInfo',
      changeLawyerDataSources: 'api/lawyerDataSourceApi/changeLawyerDataSources',
      batchLawyerDS: 'api/lawyerDataSourceApi/batchLawyerDS'
    },
    lawyerLog: {
      getList: 'api/lawyerLog/getList'
    }
  }
}
